import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {
    /**
     * Cherche les client avec les paramètres de l'objet passé en paramètre
     *
     * @param   {object}  oCritere  Objet de paramètres
     *
     * @return  {Promise}           Promise contenant le resultat
     */
    getCustomer(oCritere) {

      let params = {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
        ...oCritere
      };
        
      if (params.fncli === '') { params.fncli = '00000' }

      return Network.execute('GET', 'CWEBS0002A', params);
    },
    /**
     * [getDevise description]
     *
     * @return  {[type]}  [return description]
     */
    getCurrency(pcsoc) {
      return Network.execute('GET', 'CWEBS0012A', {
        pcsoc: Store.getters['application/get_application_company'].PCSOC ? Store.getters['application/get_application_company'].PCSOC : pcsoc,
      });
    },
    /**
     * Récupère la liste des pays
     *
     * @return  {Promise}  Promise contenant le resultat
     */
    getCountry(pcsoc) {
      return Network.execute('GET', 'CWEBS0013A', {
        // piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC ? Store.getters['application/get_application_company'].PCSOC : pcsoc,
      });
    },
    /**
     * Récupère la liste des pays
     *
     * @return  {Promise}  Promise contenant le resultat
     */
    getDistrict(country_code, pcsoc) {
      return Network.execute('GET', 'CWEBS0077A', {
        pcsoc: Store.getters['application/get_application_company'].PCSOC ? Store.getters['application/get_application_company'].PCSOC : pcsoc,
        pcpays: country_code
      });
    },
    /**
     * Récupère la liste des salons
     *
     * @return  {Promise} 
     */
    getSalon() {
      return Network.execute('GET', 'CWEBS0010A', {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
      });
    },
    /**
     * Récupère la liste des fonction des contacts d'un client
     *
     * @return  {Promise}
     */
    getFonction() {
      return Network.execute('GET', 'CWEBS0011A', {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
      });
    },
    /**
     * [getType description]
     *
     * @return  {Promise}
     */
    getType() {
      return Network.execute('GET', 'CWEBS0016A', {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
      });
    },
    /**
     * Récupère la liste des divisions d'un client 
     *
     * @return  {Promise}
     */
    getDivision(pcsoc) {
      return Network.execute('GET', 'CWEBS0014A', {
        pcsoc: Store.getters['application/get_application_company'].PCSOC ? Store.getters['application/get_application_company'].PCSOC : pcsoc,
      });
    },
    /**
     * [getSignUpCompany description]
     *
     * @return  {[type]}  [return description]
     */
    getSignUpCompany() {
      return Network.execute('GET', 'CWEBS0081A');
    },
    /**
     * Récupère a liste des sous divisions d'un client
     *
     * @param   {String}  sValeurDivision  Division principal
     *
     * @return  {Promise}
     */
    getSousDivision(sValeurDivision, pcsoc) {
      return Network.execute('GET', 'CWEBS0015A', {
        pcsoc: Store.getters['application/get_application_company'].PCSOC ? Store.getters['application/get_application_company'].PCSOC : pcsoc,
        pcdiv: sValeurDivision
      });
    },
    /**
     * Récupère la liste des contacts d'un client
     *
     * @param   {integer}  nNumClient  Numéro client
     *
     * @return  {Promise}
     */
    getContact(nNumClient = 0) {
      return Network.execute('GET', 'CWEBS0023A', {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
        pnocli: nNumClient
      });
    },
    /**
     * 
     *
     * @return  {Promise}
     */
    getTypeCom() {
      return Network.execute('GET', 'CWEBS0016A', {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
      });
    },
    /**
     *
     *
     * @return  {Promise}
     */
    getLang(pcsoc) {
      return Network.execute('GET', 'CWEBS0030A', {
        pcsoc: Store.getters['application/get_application_company'].PCSOC ? Store.getters['application/get_application_company'].PCSOC : pcsoc,
      });
    },
    /**
     * Récupération des addresses de livraison
     * et de facturation d'un client
     *
     * @return  {Promise} 
     */
    getCustomerAddress(mode, pnocl) {
      
      return Network.execute('GET', 'CWEBS0065A', {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
        pnocl: mode === 'cart' || mode === 'account' ? Store.getters['application/get_application_customer'].TNCLI : pnocl
      });
    },
    sendCustomerAddress(object) {

      let post_data = {
        ds_i: {
          OUT: [object]  
        } 
      };
      
      let data = {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
        pnocl: Store.getters['application/get_application_customer'].TNCLI,
      }
  
      return Network.execute('POST', 'CWEBS0066A', data, post_data, {
        'content-type': 'application/json'
      });  
    },
    /**
     * [getContactInfo description]
     *
     * @return  {[type]}  [return description]
     */
    getContactInfo() {
      return Network.execute('GET', 'CWEBS0071A', {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC
      });
    },
    /**
     * [uploadContactAttachment description]
     *
     * @return  {[type]}  [return description]
     */
    uploadContactAttachment(form_file, pnum_ev) {
  
      const files = [...form_file.file];
    
      const form_data = new FormData();

      files.map((file, index) => {
        form_data.append('files['+index+']', file);
      });

      form_data.append('pnum_ev', pnum_ev);
      form_data.append('pcsoc', Store.getters['application/get_application_company'].PCSOC);
      form_data.append('pnocl', Store.getters['application/get_application_customer'].TNCLI);

      return Network.execute('POST', 'upload_contact_attachment', {}, form_data, {
        'Content-Type': 'multipart/form-data'
      });
    },
    /**
     * [sendContactForm description]
     *
     * @param   {[type]}  object  [object description]
     *
     * @return  {[type]}          [return description]
     */
    sendContactForm(object) {

      let post_data = {
        ds_i: object  
      };
      
      let data = {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
        pnocl: Store.getters['application/get_application_customer'].TNCLI,
      }
  
      return Network.execute('POST', 'CWEBS0069A', data, post_data, {
        'content-type': 'application/json'
      });  
    },
    /**
     * [sendFilePath description]
     *
     * @param   {[type]}  pchemin  [pchemin description]
     * @param   {[type]}  pnum_ev  [pnum_ev description]
     *
     * @return  {[type]}           [return description]
     */
    sendFilePath(pchemin, pnum_ev) {

      let data = {
        piduser: Store.getters['application/get_application_user'].id,
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
        pnocl: Store.getters['application/get_application_customer'].TNCLI,
        pnum_ev,
        pchemin
      }
  
      return Network.execute('POST', 'CWEBS0079A', data, {}, {
        'content-type': 'application/json'
      });  
    },
    getDivLogo() {
      return Network.execute('GET', 'get_div_logo', {
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
        pmarqcli: Store.getters['application/get_application_company'].PMARQCLI,
        pdiv_princ: Store.getters['application/get_application_company'].PDIV_PRINC,
      });
    },
    getGeneralInfos() {
      return Network.execute('GET', 'CWEBS0085A', {
        pcsoc: Store.getters['application/get_application_company'].PCSOC,
        piduser: Store.getters['application/get_application_user'].id,
        pnocl: Store.getters['application/get_application_customer'].TNCLI !== undefined ? Store.getters['application/get_application_customer'].TNCLI : null ,
      });
    },
    getCustomerExist(company, customer_id) {
      return Network.execute('GET', 'CWEBS0087A', {
        pcsoc: company,
        pnocl: customer_id
      });
    },
}